import axios, { AxiosResponse } from "axios";
import { appConfig } from "../configs";
import { axios as axiosCustom } from "../plugins";
import { apiEndpoints } from "../constants/apiEndpoints";
import { authHelper } from ".";
import routes from "../constants/routes";
import { useNavigate } from "react-router-dom";
import { Routes } from "../constants";
import {PROXY_API_URL} from "../configs/app";
export const fetchLogin = async (email: string, password: string) => {
  try {
    const response = await axiosCustom.post(
      `${appConfig.PROXY_API_URL}/login`,
      {
        username: email,
        password: password,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const fetchSendPasswordResetEmail = async (email: string) => {
  try {
    const response = await axiosCustom.post(
      `${appConfig.SSO_SYNC_API}/send-password-reset-email`,
      {
        email,
      },
      {
        headers: {
          "x-api-key": appConfig.X_API_KEY,
        },
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const fetchUpdateUserMeataData = async (
  user_id: string,
  body: IUserMetaDataApi
) => {
  try {
    const response = await axiosCustom.patch(
      `${appConfig.API_URL}/api/v2/users/${user_id}`,
      {
        user_metadata: body,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

/*
export const fetchGetUserAuth0ByEmail = async (email: string) => {
  try {
    const response = await axiosCustom.get(
      `${appConfig.PROXY_API_URL}/users-by-email`,
      {
        params: {
          email,
        },
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};
*/

export const fetchRegister = async (email: string, password: string) => {
  try {
    const response = await axiosCustom.post(
      `${appConfig.API_URL}/api/v2/users`,
      {
        email,
        password,
        email_verified: false,
        connection: "Username-Password-Authentication",
        user_metadata: { isActive: true },
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const fetchSendMailVerify = async (user_id: string) => {
  try {
    const response = await axiosCustom.post(
      `${appConfig.API_URL}/api/v2/jobs/verification-email`,
      {
        user_id,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const fetchUserInfo = async () => {
  try {
    const response = await axiosCustom.get(
      `${appConfig.API_URL}/userinfo`
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const fetchChangeEmail = async (userId: string, email: string) => {
  try {
    const response = await axiosCustom.patch(apiEndpoints.changeEmail(userId), {
      email,
    });
    return response;
  } catch (err) {
    if (!(err instanceof Error)) {
      const res = err as AxiosResponse;
      return {
        error: true,
        message: res.data.error_description ?? res.data.error,
        status: res.status,
      };
    }
  }
};

export const fetchEmailChange = async (auth0UserId: string, email: string) => {
  try {
    const response = await axiosCustom.post(
      `${appConfig.SSO_SYNC_API}/email-change`,
      {
        auth0UserId,
        email,
      },
      {
        headers: {
          "x-api-key": appConfig.X_API_KEY,
        },
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const fetchEmailChangeConfirm = async (
  auth0UserId: string,
  ticket: string
) => {
  try {
    const response = await axiosCustom.post(
      `${appConfig.SSO_SYNC_API}/email-change-confirm`,
      {
        auth0UserId,
        ticket,
      },
      {
        headers: {
          "x-api-key": appConfig.X_API_KEY,
        },
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const fetchChangePassword = async (email: string) => {
  try {
    const response = await axiosCustom.post(apiEndpoints.changePassword, {
      email,
      client_id: appConfig.AUTH0_CLIENT_ID,
      connection: "Username-Password-Authentication",
    });
    return response;
  } catch (err) {
    throw err;
  }
};

export const fetchDeleteAccount = async (userId: string) => {
  try {
    const response = await axiosCustom.delete(
      apiEndpoints.deleteAccount(userId)
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const fetchUpdateUserMetaData = async (
  user_id: string,
  body: IUserMetaDataApi
) => {
  try {
    const response = await axiosCustom.patch(
      `${appConfig.API_URL}/api/v2/users/${user_id}`,
      {
        user_metadata: body,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

// SYNC_APIを叩いてユーザーのメタデータを更新する
// フル権限で更新するので多様しないように
export const updateUserMetadata = async (
  email: string,
  user_id: string,
  body: IUserMetaDataApi
) => {
  try {
    const response = await axiosCustom.post(
      `${appConfig.SSO_SYNC_API}/update-user-metadata`,
      {
        email,
        auth0UserId: user_id,
        userMetadata: body,
      },
      {
        headers: {
          "x-api-key": appConfig.X_API_KEY,
        },
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
}

export const fetchGetAddressData = async (zipCode: string) => {
  try {
    const response = await axios.get(
      `https://api.zipaddress.net/?zipcode=${zipCode}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const fetchSessionProxy = async (body: IPostSession) => {
  try {
    const response = await axios.post(
      `${appConfig.PROXY_API_URL}/session`,
      body,
      {
        withCredentials: true,
      }
    );
    localStorage.removeItem("isLogin");
    return response;
  } catch (err) {
    throw err;
  }
};

// n: force refresh user info (0: no, 1: yes)
export const fetchUserInfoProxy = async (n = 0) => {
  try {
    const checkSesion = await axios.post(
      `${appConfig.PROXY_API_URL}/session/validate`,
      {},
      {
        withCredentials: true,
      }
    );
    if (checkSesion.status === 200) {
      const response = await axios.get(`${appConfig.PROXY_API_URL}/user_info?n=${n}`, {
        withCredentials: true,
      });
      return response;
    }
  } catch (err) {
    authHelper.logOut();
    window.location.pathname = routes.USERGUEST;
  }
};

export const fetchSessionValidateProxy = async () => {
  try {
    const response = await axios.post(
      `${appConfig.PROXY_API_URL}/session/validate`,
      {},
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    authHelper.logOut();
    if (location.pathname == routes.USERGUEST) return;
    return location.pathname != routes.LOGOUT
      ? (window.location.href = routes.USERGUEST)
      : err;
  }
};

export const fetchLogoutProxy = async () => {
  try {
    const response = await axios.post(
      `${appConfig.PROXY_API_URL}/logout`,
      {},
      {
        withCredentials: true,
        headers: { "Content-Type": "application/json" },
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const fetchAddressCompany = async (data: string) => {
  try {
    const CID = appConfig.CID;
    const response = await axios.get(
      `${appConfig.API_ADDRESS_URL}/suggestsearch/companies?cid=${CID}&s=${data}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const fetchSurveyData = async (
  surveyID: string,
  user_id: string,
  includeDelay: boolean,
  user_id_hash: string
) => {
  try {
    // if (includeDelay) {
    //   await new Promise((resolve) => setTimeout(resolve, 5000));
    // }

    const encodedUserId = encodeURIComponent(user_id);
    const delayParam = includeDelay ? "&delay=2000" : "";
    const encodeUserIdHash = encodeURIComponent(user_id_hash);
    const response = await axios.get(
      `${appConfig.API_SURVEY_URL}/${surveyID}?user_id=${encodedUserId}&survey_id=${surveyID}${delayParam}&id=${encodeUserIdHash}`
    );

    return response.data;
  } catch (err) {
    // Error handling
  }
};

export const fetchListEventEntries = async (
  access_token: string,
  query: string = ""
) => {
  try {
    const response = await axios.get(
      `${appConfig.EVENT_API_URL}/users/events/entries?limit=5&${query}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const deleteUserEventEntries = async (
  access_token: string,
  session_ids: string
) => {
  try {
    const response = await axios.delete(
      `${appConfig.EVENT_API_URL}/users/events/entries?session_ids=${session_ids}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const getSurveyId = async (web_url_id: string) => {
  try {
    const response = await axios.get(
      `${appConfig.EVENT_API_URL}/survey/${web_url_id}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const getSurveyDetail = async (survey_id: string) => {
  try {
    const response = await axios.get(
      `${appConfig.EVENT_API_URL}/surveys/${survey_id}/details`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const fetchChangePasswordV2 = async (
  userId: string,
  password: string
) => {
  try {
    const response = await axiosCustom.patch(
      `${appConfig.API_URL}/api/v2/users/${userId}`,
      {
        password,
      }
    );
    return response;
  } catch (err) {
    if (!(err instanceof Error)) {
      const res = err as AxiosResponse;
      return {
        error: true,
        message: res.data.error_description ?? res.data.error,
        status: res.status,
      };
    }
  }
};

export const getSurveyCollectors = async (survey_id: string) => {
  try {
    const response = await axios.get(
      `${appConfig.EVENT_API_URL}/surveys/${survey_id}/collectors`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const postSurveyResponses = async (
  collector_id: string,
  payload: {
    ip_address?: string;
    pages?: IAnswerPage[];
  }
) => {
  try {
    const response = await axios.post(
      `${appConfig.EVENT_API_URL}/collectors/${collector_id}/responses`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    );
    console.log("postSurveyResponses success:", response);
    return response;
  } catch (err) {
    console.log("Error in postSurveyResponses:", err);
    return "OK";
  }
};

export const registerSession = async (event_id: string, session_id: string, plans: string, checkPay: boolean) => {
  try {
    const response = await axios.put(
      `${appConfig.EVENT_API_URL_SAME_SUB_DOMAIN}/events/${event_id}/user/sessions/entries_by_session?session_id=${session_id}&plans=${plans}`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const postSurveyAndRegisterSessionAndUpdateUser = async (
  collector_id: string, 
  payload: {
    survey:{
      ip_address?: string;
      pages?: IAnswerPage[];
    },
    user: {user_metadata: IUserMetaDataApi}
  },
  event_id: string,
  session_id: string,
  plans: string,
) => {
  try {
    const response = await axios.post(
      `${appConfig.EVENT_API_URL_SAME_SUB_DOMAIN}/survey_and_event_and_user_update/entry?event_id=${event_id}&collector_id=${collector_id}&session_id=${session_id}&plans=${plans}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${authHelper.accessToken()}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};


export const getEventSessionEntries = async (event_id: string) => {
  try {
    const response = await axios.get(
      `${appConfig.EVENT_API_URL_SAME_SUB_DOMAIN}/events/${event_id}/user/sessions/entries_by_session`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const getEventMicroCMS = async (event_id: string) => {
  try {
    const response = await axios.get(
      `${appConfig.EVENT_API_URL}/microcms/events/${event_id}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const findEventMicroCMS = async (event_id: string) => {
  try {
    const response = await axios.get(
      `${appConfig.EVENT_API_URL}/microcms/find/events/${event_id}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const createSSOBasicUser = async (email: string, password: string) => {
  try {
    const response = await axios.post(
      `${appConfig.SSO_SYNC_API}/create-basic-user`,
      {
        email,
        password,
      },
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const createBasicUser = async (email: string, password: string, additionalInfo: object) => {
  try {
    const response = await axios.post(
      `${appConfig.SSO_SYNC_API}/create-basic-user-with-info`,
      {
        email,
        password,
        additionalInfo,
      },
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const authenticateSSOUser = async (
  email: string,
  auth0UserId: string
) => {
  try {
    const response = await axios.post(
      `${appConfig.SSO_SYNC_API}/authenticate-sso-user`,
      {
        email,
        auth0UserId,
      },
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const fetchResetPassword = async (
  email: string,
  password: string,
  ticketId: string
) => {
  try {
    const response = await axios.post(
      `${appConfig.SSO_SYNC_API}/password-reset`,
      {
        email,
        password,
        ticketId,
      },
      {
        headers: {
          "x-api-key": appConfig.X_API_KEY,
        },
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateUserPassword = async (
  email: string,
  auth0UserId: string,
  password: string
) => {
  try {
    const response = await axios.post(
      `${appConfig.SSO_SYNC_API}/update-user-password`,
      {
        email,
        auth0UserId,
        password,
      },
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const fetchResignUser = async (
  ssoUserId: string,
  auth0UserId: string,
  reasonForWithdrawal: string
) => {
  try {
    const response = await axios.post(
      `${appConfig.SSO_SYNC_API}/resign-user`,
      {
        ssoUserId,
        auth0UserId,
        reasonForWithdrawal,
      },
      {
        withCredentials: true,
        headers: {
          // MEMO:
          // - SDK_WEB-1187
          // - 本人検証に必要
          Authorization: authHelper.accessToken(),
        },
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const checkEmailExists = async (
  email: string,
  verifyEmail: boolean = false
) => {
  try {
    const response = await axios.post(
    `${appConfig.SSO_SYNC_API}/check-email-exists`,
      {
        email,
        verifyEmail
      },
      {
        withCredentials: true,
      }
    )
    return response;
  } catch (err) {
    throw err;
  }
}
export const fetchCreateAccountSF = async (body: IAccountSFAPI) => {
  try {
    const response = await axios.post(
      `${appConfig.EVENT_API_URL}/salesforce/account`,
      body,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const fetchCreateContactSF = async (body: IContactSFAPI) => {
  try {
    const response = await axios.post(
      `${appConfig.EVENT_API_URL}/salesforce/contact`,
      body,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const getDetailSF = async (query: string) => {
  try {
    const response = await axios.get(
      `${appConfig.EVENT_API_URL}/salesforce/search?q=${query}`,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const updateAccountSF = async (id: string, body: IAccountSFAPI) => {
  try {
    const response = await axios.patch(
      `${appConfig.EVENT_API_URL}/salesforce/account/${id}`,
      body,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const updateContactSF = async (id: string, body: IContactSFAPI) => {
  try {
    const response = await axios.patch(
      `${appConfig.EVENT_API_URL}/salesforce/contact/${id}`,
      body,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const deleteAccountSF = async (id: string) => {
  try {
    const response = await axios.delete(
      `${appConfig.EVENT_API_URL}/salesforce/account/${id}`,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const deleteContactSF = async (id: string) => {
  try {
    const response = await axios.delete(
      `${appConfig.EVENT_API_URL}/salesforce/contact/${id}`,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const handleSyncCustomerInfo = async (body: ISyncCustomeSf) => {
  try {
    const response = await axios.post(
      `${appConfig.EVENT_API_URL}/salesforce/SyncCustomerInfo`,
      body,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const handleSearchCustomerInfo = async (
  SsoID__c: string,
  LastName: string,
  FirstName: string,
  Company__pc: string,
  PersonEmail: string
) => {
  try {
    const response = await axios.post(
      `${appConfig.EVENT_API_URL}/salesforce/SearchCustomerInfo`,
      {
        SsoID__c,
        LastName,
        FirstName,
        Company__pc,
        PersonEmail,
      },
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const handleFetchAccountInfo = async (account_id: string) => {
  try {
    const response = await axios.get(
      `${appConfig.EVENT_API_URL}/salesforce/account/${account_id}`,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const handleFetchContactInfo = async (contact_id: string) => {
  try {
    const response = await axios.get(
      `${appConfig.EVENT_API_URL}/salesforce/contact/${contact_id}`,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const upsertAccountAndSyncSF = async (
  getDetailSFRequest: {
    SsoID__pc: string,
    Company__pc: string,
    PersonEmail: string
  },
  updateAccountSFRequest: IAccountSFAPI,
  handleSearchCustomerInfoRequest: {
    SsoID__c: string,
    LastName: string,
    FirstName: string,
    Company__pc: string,
    PersonEmail: string
  },
  fetchCreateAccountSFRequest:IAccountSFAPI,
  handleSyncCustomerInfoRequest:ISyncCustomeSf
) => {
  try {
    const requestBody = {
      getDetailSFRequest: getDetailSFRequest,
      updateAccountSFRequest: updateAccountSFRequest,
      handleSearchCustomerInfoRequest: handleSearchCustomerInfoRequest,
      fetchCreateAccountSFRequest: fetchCreateAccountSFRequest,
      handleSyncCustomerInfoRequest: handleSyncCustomerInfoRequest
    }
    const response = await axios.post(
      `${appConfig.EVENT_API_URL}/salesforce/upsertAccountAndSync`,
      requestBody,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const handleFetchSurveyData = async (
  survey_id: string,
  user_id: string,
  includeDelay: boolean,
  user_id_hash: string
) => {
  try {
    const encodedUserId = encodeURIComponent(user_id);
    const delayParam = includeDelay ? "&delay=2000" : "";
    const encodeUserIdHash = encodeURIComponent(user_id_hash);
    const response = await axios.get(
      `${appConfig.EVENT_API_URL}/users/survey-data/${survey_id}?user_id=${encodedUserId}&${delayParam}&id=${encodeUserIdHash}`,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const getOrderIds = async (user_id: string) => {
  try {
    const response = await axios.get(
      `${appConfig.EVENT_API_URL}/users/subscription/${user_id}/remaining-orders`,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const getVideoSession = async (access_token: string, session_id: string) => {
  try {
    const response = await axios.get(
      `${appConfig.EVENT_API_URL}/users/session/${session_id}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const postClipping = async () => {
  try {
    const response = await axios.post(
      `${appConfig.EVENT_API_URL_SAME_SUB_DOMAIN}/users/clipping`,
      {
        page_path: "/news/000417.php",
      },
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const getClipping = async () => {
  try {
    const response = await axios.get(
      `${appConfig.EVENT_API_URL_SAME_SUB_DOMAIN}/users/clipping`,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const deleteClipping = async (id : number) => {
  try {
    const response = await axios.delete(
      `${appConfig.EVENT_API_URL_SAME_SUB_DOMAIN}/users/clipping/${id}`,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const deleteAllClipping = async () => {
  try {
    const response = await axios.delete(
      `${appConfig.EVENT_API_URL_SAME_SUB_DOMAIN}/users/all-clipping`,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const postMassmedian = async (email:string, phone:string) => {
  try {
    const response = await axios.post(
      `${appConfig.EVENT_API_URL_SAME_SUB_DOMAIN}/users/change_job/kgj`,
      {
        email: email,
        phone_number: phone
      },
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};
